export default __webpack_public_path__ + "static/media/554.cc4d7cbb.gif";